import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_MONTHLY_REPORT = "[MONTHLY_REPORT] GET_MONTHLY_REPORT";
export const GET_MONTHLY_REPORT_SUCCESS =
	"[MONTHLY_REPORT] GET_MONTHLY_REPORT_SUCCESS";
export const GET_MONTHLY_REPORT_FAILED =
	"[MONTHLY_REPORT] GET_MONTHLY_REPORT_FAILED";

export const SET_VALUE = "[MONTHLY_REPORT] SET_VALUE";
export const CLEAR_VALUES = "[MONTHLY_REPORT] CLEAR_VALUES";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getMonthlyReport(
	skip,
	take,
	sort,
	desc,
	filters,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_MONTHLY_REPORT });
		try {
			const { login } = getState();

			const filterQuery = Object.keys(filters || {}).reduce(
				(query, key) =>
					filters[key] ? query + `&filters[${key}]=${filters[key]}` : query,
				""
			);

			var response = await api.sendGet(
				`/monthly-companies-report/table?skip=${skip}&take=${take}&sort=${sort ||
					"createdAt"}&desc=${desc === undefined ? true : desc}${filterQuery}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_MONTHLY_REPORT_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}
				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MONTHLY_REPORT_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_MONTHLY_REPORT_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
